import { Component, OnInit, ChangeDetectorRef, NgZone, OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CroudMarqueCategoryComponent } from '../croud-marque-category/croud-marque-category.component';
import { UniteService } from '../../../../services/categorie-unite-marque/unite.service';
import { Unite } from '../../../../models/unite';
import { Subscription } from 'rxjs';
import {ParametreService} from '../../main-parametre/parametre.service';

@Component({
    selector: 'app-parametre-unite',
    templateUrl: './parametre-unite.component.html',
    styleUrls: ['./parametre-unite.component.scss']
})
export class ParametreUniteComponent implements OnInit, OnDestroy {
    unites: Unite[] = [];
    idStation: number = 0;
    idUser: number = 0;
    isLoading: boolean = false;
    private addItemSubscription: Subscription;

    constructor(
        private uniteService: UniteService,
        private toastr: ToastrService,
        private router: Router,
        private modalService: NgbModal,
        private cdr: ChangeDetectorRef,
        private ngZone: NgZone,
        private parametreService: ParametreService
    ) {
        this.addItemSubscription = this.parametreService.addItem$.subscribe(event => {
            if (event.subType === 'unité') {
                this.addUnite(event.idStation);
            }
        });
    }

    ngOnInit(): void {
        this.loadUserData();
    }

    ngOnDestroy(): void {
        this.addItemSubscription.unsubscribe();
    }

    loadUserData(): void {
        const user = localStorage.getItem('currentUser');
        if (user) {
            const currentUser = JSON.parse(user);
            console.log('Current User:', currentUser);
            this.idUser = currentUser?.id || 0;
            if (currentUser?.stations?.length > 0) {
                this.idStation = currentUser.stations[0].id;
                console.log('User ID:', this.idUser, 'Station ID:', this.idStation);
                this.loadUnites();
            } else {
                this.toastr.error('Aucune station trouvée. Veuillez créer une station.', 'Erreur');
                this.router.navigate(['/create-station']);
            }
        } else {
            this.toastr.error('Utilisateur non connecté.', 'Erreur');
            this.router.navigate(['/pages/authentication/login-v2']);
        }
    }

    loadUnites(): void {
        if (this.idUser && this.idStation) {
            this.isLoading = true;
            this.uniteService.getAll(this.idStation, this.idUser).subscribe({
                next: (unites) => {
                    this.unites = [...unites];
                    this.isLoading = false;
                    console.log('Units loaded:', this.unites);
                    if (unites.length === 0) {
                       // this.toastr.info('Aucune unité trouvée pour cette station.', 'Information');
                    }
                    this.cdr.detectChanges();
                },
                error: (error) => {
                    this.isLoading = false;
                    console.error('API Error:', error);
                    this.toastr.error(error.message || 'Erreur lors du chargement des unités.', 'Erreur');
                }
            });
        } else {
            this.toastr.error('Informations utilisateur ou station manquantes.', 'Erreur');
        }
    }

    addUnite(idStation: number): void {
        this.idStation = idStation || this.idStation;
        const modalRef = this.modalService.open(CroudMarqueCategoryComponent, {
            size: 'lg',
            centered: true,
            backdrop: 'static',
            keyboard: false
        });
        modalRef.componentInstance.modalSubType = 'unité';
        modalRef.componentInstance.idStation = this.idStation;
        modalRef.result.then(
            (newUnite: Unite) => {
                this.ngZone.run(() => {
                   // console.log('Received new unit in addUnite:', newUnite);
                  /*  console.log('Is newUnite valid?', {
                        hasLibelle: !!newUnite.libelle,
                        hasId: !!newUnite.id,
                        idNonZero: newUnite.id > 0
                    });*/
                    if (newUnite && newUnite.libelle && newUnite.id > 0) {
                        this.unites = [newUnite, ...this.unites];
                       // console.log('Updated unites:', this.unites);
                        setTimeout(() => {
                            this.cdr.detectChanges();
                          //  console.log('Change detection triggered');
                        }, 0);
                    } else {
                        console.warn('Invalid unit received:', newUnite);
                        this.toastr.warning('Unité non ajoutée localement, actualisation de la liste.', 'Avertissement');
                        this.loadUnites();
                    }
                });
            },
            (reason) => {
                this.ngZone.run(() => {
                  //  console.log('Modal dismissed:', reason);
                    if (reason === 'Erreur lors de l\'enregistrement') {
                        this.toastr.error('Erreur lors de l\'ajout, actualisation de la liste.', 'Erreur');
                        this.loadUnites();
                    }
                });
            }
        ).catch((error) => {
           // console.error('Modal promise error:', error);
            this.ngZone.run(() => {
                this.toastr.error('Erreur inattendue lors de la fermeture du modal.', 'Erreur');
                this.loadUnites();
            });
        });
    }

    editUnite(unite: Unite): void {
        const modalRef = this.modalService.open(CroudMarqueCategoryComponent, {
            size: 'lg',
            centered: true,
            backdrop: 'static',
            keyboard: false
        });
        modalRef.componentInstance.modalSubType = 'unité';
        modalRef.componentInstance.idStation = this.idStation;
        modalRef.componentInstance.existingData = { ...unite };
        modalRef.componentInstance.isEditMode = true;
        modalRef.result.then(
            (updatedUnite: Unite) => {
                this.ngZone.run(() => {
                 //   console.log('Received updated unit in editUnite:', updatedUnite);
                  /*  console.log('Is updatedUnite valid?', {
                        hasLibelle: !!updatedUnite.libelle,
                        hasId: !!updatedUnite.id,
                        idNonZero: updatedUnite.id > 0
                    });*/
                    if (updatedUnite && updatedUnite.libelle && updatedUnite.id > 0) {
                        this.unites = this.unites.map(u =>
                            u.id === updatedUnite.id ? updatedUnite : u
                        );
                      //  console.log('Updated unites:', this.unites);
                        this.toastr.success('Unité mise à jour !', 'Succès');
                        setTimeout(() => {
                            this.cdr.detectChanges();
                        //    console.log('Change detection triggered');
                        }, 0);
                    } else {
                        console.warn('Invalid unit received:', updatedUnite);
                        this.toastr.warning('Unité non mise à jour localement, actualisation de la liste.', 'Avertissement');
                        this.loadUnites();
                    }
                });
            },
            (reason) => {
                this.ngZone.run(() => {
                  //  console.log('Modal dismissed:', reason);
                    if (reason === 'Erreur lors de l\'enregistrement') {
                        this.toastr.error('Erreur lors de la mise à jour, actualisation de la liste.', 'Erreur');
                        this.loadUnites();
                    }
                });
            }
        ).catch((error) => {
            console.error('Modal promise error:', error);
            this.ngZone.run(() => {
                this.toastr.error('Erreur inattendue lors de la fermeture du modal.', 'Erreur');
                this.loadUnites();
            });
        });
    }
}
